import { useState } from 'react';
import { ExternalLink, Megaphone, RefreshCw } from 'lucide-react';
import { t } from '../i18n';
import { useAppStore } from '../store/useAppStore';
import type { Enrollment } from '../api/client';

/**
 * Majburiy kanal: oʻquvchi aʼzo boʻlmaguncha shu kursning darslari
 * yopiq (server ham 403 beradi — bu ekran faqat tushuntiradi).
 *
 * "Tekshirish" `/auth/me?fresh=1` ni chaqiradi: server Telegram'dan
 * keshsiz soʻraydi, aks holda kanalga endi qoʻshilgan oʻquvchi yarim
 * daqiqa kutib qolardi.
 */
export function ChannelGate({ enrollment }: { enrollment: Enrollment }) {
  const resolveIdentity = useAppStore((s) => s.resolveIdentity);
  const clearCourse = useAppStore((s) => s.clearCourse);
  const enrollments = useAppStore((s) => s.enrollments);
  const [checking, setChecking] = useState(false);
  const [stillNot, setStillNot] = useState(false);
  const link = enrollment.channel?.link ?? null;

  const open = () => {
    if (!link) return;
    const tg = window.Telegram?.WebApp;
    if (tg?.openTelegramLink) tg.openTelegramLink(link);
    else window.open(link, '_blank', 'noopener,noreferrer');
  };

  const check = async () => {
    setChecking(true);
    await resolveIdentity(true);
    setChecking(false);
    const now = useAppStore
      .getState()
      .enrollments.find((e) => e.enrollmentId === enrollment.enrollmentId);
    setStillNot(now?.channel?.member === false);
  };

  return (
    <main className="page">
      <div className="empty channel-gate">
        <Megaphone
          size={32}
          aria-hidden="true"
          className="channel-gate__icon"
        />
        <h1 className="empty-title">{t('Kanalga aʼzo boʻling')}</h1>
        <p className="empty-text">
          {t(
            '«{course}» kursi darslarini ochish uchun ustozingiz kanalga aʼzo boʻlishni soʻragan.',
            { course: enrollment.courseTitle ?? enrollment.groupName ?? '' },
          )}
        </p>
        {link && (
          <button type="button" className="btn btn-primary" onClick={open}>
            <ExternalLink size={16} aria-hidden="true" />
            {t('Kanalga oʻtish')}
          </button>
        )}
        <button
          type="button"
          className="btn btn-secondary"
          onClick={check}
          disabled={checking}
        >
          <RefreshCw size={16} aria-hidden="true" />
          {checking ? t('Tekshirilmoqda…') : t('Aʼzo boʻldim — tekshirish')}
        </button>
        {stillNot && (
          <p className="callout callout-warning text-sm" role="status">
            {t('Hali aʼzo emassiz. Kanalga qoʻshilib, qayta tekshiring.')}
          </p>
        )}
        {enrollments.length > 1 && (
          <button type="button" className="btn btn-ghost" onClick={clearCourse}>
            {t('Boshqa kursni tanlash')}
          </button>
        )}
      </div>
    </main>
  );
}
